export default __webpack_public_path__ + "static/time-title-252ef3119d57e9b7ef13230ff2b948f7.png";